import { spacing } from '../spacing'
import { type ComponentCreation } from './types'
import type { Tokens } from '../augmentation'

export const createMuiDrawer = ({ palette }: Pick<Tokens, 'palette'>) =>
  ({
    MuiDrawer: {
      styleOverrides: {
        root: {
          '&.MuiModal-root:not(.DhlDrawer-fullscreen):not(.DhlWithDrawer) > .MuiPaper-root': {
            borderRadius: spacing(1.5, 1.5, 0, 0),
          },
          '& .DhlModal-base': {
            // Style any parent (e.g., form) that is wrapped around DhlModal-* elements
            '& > :only-child:not(.DhlModal-content)': {
              display: 'flex',
              flex: 1,
              flexDirection: 'column',
              height: 0,
            },
          },

          '&.DhlDrawer-fullscreen': {
            padding: 0,

            '& > .MuiPaper-root': {
              borderRadius: 0,
              width: '100%',
              height: '100%',

              '&.MuiDrawer-paper > .MuiPaper-root': {
                flex: 1,
              },
            },
          },

          '& .DhlDrawer-edge': {
            backgroundColor: palette.background.paper,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'flex-end',
            position: 'relative',
            zIndex: 2,

            '& + .MuiPaper-root': {
              marginTop: spacing(-2),
              position: 'relative',
              zIndex: 1,
            },

            '&-inner': {
              width: 43,
              minHeight: 4,
              backgroundColor: palette.dark.light,
              borderRadius: 0.5,
              marginTop: spacing(2),
              marginBottom: spacing(2),
            },
          },
        },
      },
    },
  }) satisfies ComponentCreation
